import type { ApiV2Article } from '@dce-front/hodor-types/api/v2/article/definitions';

export const getCreativeMediaFormatted = (data: ApiV2Article): ApiV2Article =>
  data;
